module.exports = __webpack_public_path__ + "img/search-predmet-icon.3b45eac9.svg";